import { render } from "./SignIn.vue?vue&type=template&id=036ccf81&scoped=true&bindings={\"appLogo\":\"setup\"}"
import script from "./SignIn.vue?vue&type=script&lang=js"
export * from "./SignIn.vue?vue&type=script&lang=js"

import "./SignIn.vue?vue&type=style&index=0&id=036ccf81&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-036ccf81"

export default script